<template>
  <div class="nc-holder">
    <div :style="{background:this.variant}" class="nc-border"></div>
      <div class="nc-right">
        <div class="nc-title">
        <span class="title">Waiter Request</span>
      </div>
      <div class="nc-body">
       <p class="topic"> New waiter request on table {{item.number}}</p>
       <p class="message">Message: {{item.message}}</p>
       <p class="time">{{ item.timestamp.toDate() | moment("calendar") }}</p>
      </div>
      </div>
  </div>
</template>

<script>
import moment from "moment"
export default {
props:{
  item:Object
},
components:{
  
},
computed:{
   variant(){
     switch(this.item.type){
       case "waiter_request":
         return "#f96332"
      default :
      return "#18ce0fcc"
     }
   }
},
}
</script>

<style scoped>
.nc-holder {
    background: white;
    border-radius: 5px;
    display: grid;
    grid-template-columns: 5px 1fr;
    margin-bottom: 10px;

}

.nc-border {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}

.nc-right {
    padding: 5px;
}

p{
  margin-bottom: 0;
}

.topic,.message {
    font-size: 12px;
    font-weight: 500;
}
p.time {
    font-size: 10px;
    font-weight: 500;
}
</style>